// extracted by mini-css-extract-plugin
export var chevron = "_8p-2";
export var dropdownItems = "_8p-0";
export var item = "_8p-1";